/** API command outcomes that do not represent a persisted terminal AI-job error. */
export const AI_JOB_COMMAND_ERROR_CODES = {
  DEVICE_DAILY_FREE_CREDITS_ALREADY_CLAIMED:
    'DEVICE_DAILY_FREE_CREDITS_ALREADY_CLAIMED',
  DISPATCH_UNCONFIRMED: 'AI_JOB_DISPATCH_UNCONFIRMED',
} as const;
